import { RadioGroup, RadioGroupInterface } from '@systemeio/ui'
import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
  PathValue,
  UseFormSetValue,
} from 'react-hook-form'

type RadioGroupRhfProps<
  T extends string,
  TValues extends FieldValues,
  TName extends FieldPath<TValues>,
> = Omit<RadioGroupInterface<T>, 'onChange' | 'selected'> &
  Omit<ControllerProps<TValues, TName>, 'render'> & { setValue: UseFormSetValue<TValues> }

function RadioGroupRhf<
  T extends string,
  TValues extends FieldValues,
  TName extends FieldPath<TValues>,
>(props: RadioGroupRhfProps<T, TValues, TName>) {
  const { setValue, control, name, rules, ...restProps } = props

  const handleChange = (value: T) => setValue(name, value as PathValue<TValues, TName>)

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <RadioGroup {...restProps} selected={field.value} onChange={handleChange} />
      )}
    />
  )
}

export default RadioGroupRhf
